var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-nav cl"},_vm._l((_vm.panes),function(item,index){return _c('div',{key:item.name,staticClass:"item",class:{active:item.name===_vm.$parent.currentName,'is-disabled':item.isDisabled}},[_c('a',{on:{"click":function($event){return _vm.handleClick(index,item.name)}}},[_vm._v(_vm._s(item.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }